import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Error codes returned by intl-tel-input v29 getValidationError().
export const PHONE_VALIDATION_ERROR_CODES = {
  IS_POSSIBLE: 'IS_POSSIBLE',
  INVALID_COUNTRY_CODE: 'INVALID_COUNTRY_CODE',
  TOO_SHORT: 'TOO_SHORT',
  TOO_LONG: 'TOO_LONG',
  IS_POSSIBLE_LOCAL_ONLY: 'IS_POSSIBLE_LOCAL_ONLY',
  INVALID_LENGTH: 'INVALID_LENGTH',
  UTILS_NOT_LOADED: null,
} as const;

export function intlTelInputValidator(
  itiInstance: () => { isValidNumber: () => boolean; getValidationError: () => string | null } | null,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').trim();

    // Let required validator handle blank values.
    if (!value) {
      return null;
    }

    const iti = itiInstance();
    if (!iti) {
      return null;
    }

    try {
      const isValid = iti.isValidNumber();
      const errorCode = iti.getValidationError();

      // If utils are unavailable, fall back to basic format/length checks.
      if (errorCode === PHONE_VALIDATION_ERROR_CODES.UTILS_NOT_LOADED) {
        if (value.length < 7 || value.length > 15 || !/^[+]?[\d\s\-()]+$/.test(value)) {
          return {
            phoneInvalid: {
              value,
              errorCode: 'UTILS_NOT_LOADED',
            },
          };
        }

        return null;
      }

      if (!isValid && errorCode !== PHONE_VALIDATION_ERROR_CODES.IS_POSSIBLE) {
        return {
          phoneInvalid: {
            value,
            errorCode,
          },
        };
      }
    } catch {
      return null;
    }

    return null;
  };
}

export function hasPhoneValidationError(control: AbstractControl): boolean {
  return !!control?.errors?.['phoneInvalid'];
}
